import GlobalIcon2 from "../icons/globalIcon2";
import FinalFooterLine1 from "./finalFooterLine1";
import FinalFooterLine2 from "./finalFooterLine2";
import FinalFooterLine3 from "./finalFooterLine3";
import LeftLine1 from "./leftLine1";
import Line1a from "./line1a";
import Line3a from "./line3a";
import Line4a from "./line4a";
import LogOutBtn from "./logOutBtn";

export default function ProfileFooter() {
  return (
    <div className="pt-10 pb-c120">
      <Line1a/>
      <LogOutBtn/>
      <Line3a/>
      <Line4a/>
    </div>
  );
}
